
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { LoadingSpinner } from "./LoadingSpinner";
import { toast } from "sonner";

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log("ProtectedRoute: Checking authentication...");
    
    const checkAuth = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error("Erreur d'authentification:", error);
          toast.error("Erreur de vérification de l'authentification");
          setIsAuthenticated(false);
          return;
        }

        console.log("Session status:", session ? "Authenticated" : "Not authenticated");
        setIsAuthenticated(!!session);
      } catch (error) {
        console.error("Authentication check error:", error);
        toast.error("Erreur de connexion au serveur");
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      console.log("Auth state changed:", session ? "Authenticated" : "Not authenticated");
      setIsAuthenticated(!!session);
      setIsLoading(false);
    });

    checkAuth();
    return () => subscription.unsubscribe();
  }, []);

  if (isLoading) {
    console.log("ProtectedRoute: Loading...");
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    console.log("ProtectedRoute: Redirecting to auth...");
    return <Navigate to="/auth" replace />;
  }

  console.log("ProtectedRoute: Rendering protected content");
  return <>{children}</>;
};
